import TwoPeopleChatUI from 'src/components/ChatUIComponents/TwoPeopleChatUI'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { useChatManagement } from '../../hooks/useChatManagement'

const ChatContainer = ({
  profileData,
  peerChatId,
  peerChatName,
  peerChatImage,
  showNotificationsOnIncomingMessage,
}) => {
  const {
    agoraChatServerConnection,
    agoraChatId,
    agoraChatToken,
    peerOnline,
    chatsWithThisUser,
    scrollTriggerBoolean,
    chatsLoading,
    loadMoreChats,
    replaceWaitingTempMessage,
    addLocalMessageToArray,
  } = useChatManagement(profileData, peerChatId)

  return (
    <TwoPeopleChatUI
      agoraChatServerConnection={agoraChatServerConnection}
      thisUserChatId={agoraChatId}
      thisUserChatToken={agoraChatToken}
      thisUserNickname={profileData?.name || agoraChatId}
      thisUserAvatarUrl={
        profileData?.profilePicId ? getImageLink(profileData?.profilePicId) : undefined
      }
      otherUserChatId={peerChatId}
      otherUserName={peerChatName}
      otherUserPresence={peerOnline}
      otherUserRelativeRole={''}
      otherUserAvatarUrl={peerChatImage}
      arrayOfAllMessages={chatsWithThisUser}
      addLocalMessageToArray={addLocalMessageToArray}
      showNotificationsOnIncomingMessage={showNotificationsOnIncomingMessage}
      scrollTriggerBoolean={scrollTriggerBoolean}
      chatsLoading={chatsLoading}
      loadOlderChatsWithUserFunc={(otherUserId) => loadMoreChats(otherUserId)}
      replaceSpecificTempMessageWithResultMessage={(userId, tempMsgIdToReplace, resultMessage) =>
        replaceWaitingTempMessage(userId, tempMsgIdToReplace, resultMessage)
      }
      canAttachFeatures={
        localStorage.getItem('authorities') &&
        (getAllRolesInBoolean().isAdmin || getAllRolesInBoolean().isTeacher)
      }
    />
  )
}

export default ChatContainer